var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6C17.9778 6 19.9112 6.58649 21.5557 7.6853C23.2002 8.78412 24.4819 10.3459 25.2388 12.1732C25.9957 14.0004 26.1937 16.0111 25.8079 17.9509C25.422 19.8907 24.4696 21.6725 23.0711 23.0711C21.6725 24.4696 19.8907 25.422 17.9509 25.8079C16.0111 26.1937 14.0004 25.9957 12.1732 25.2388C10.3459 24.4819 8.78412 23.2002 7.6853 21.5557C6.58649 19.9112 6 17.9778 6 16C6 13.3478 7.05357 10.8043 8.92893 8.92893C10.8043 7.05357 13.3478 6 16 6Z",
    stroke: "currentColor",
    strokeWidth: 1.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.659 19.3409L14.252 14.2519L19.341 12.6589L17.748 17.7479L12.659 19.3409Z",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.82d6527b0677ae3202e6297a30148e40.svg";
export { ForwardRef as ReactComponent };